export default {
    namespaced: true,
    state: () => ({
        statuses: [],
        searches: [],
        extendedFilters: [],
        tableOptions:[],
        collection : "3",
    }),
    mutations: {
        SET_COLLECTION (state, payload) {
            state.collection = payload;
        },
        SET_STATUS (state, payload) {
            let item = state.statuses.find(x => x.collection === state.collection);
            if (!item) {
                item = { collection: state.collection, value: payload };
                state.statuses.push(item);
            }
            else 
                item.value = payload;
            const tableOption = state.tableOptions.find(x => x.collection === state.collection);
            if (tableOption) 
                tableOption.value.page = 1;
        },
        SET_SEARCH (state, payload) {
            let item = state.searches.find(x => x.collection === state.collection);
            if (!item) {
                item = { collection: state.collection, value: payload};
                state.searches.push(item);
            }
            else 
                item.value = payload;
            const tableOption = state.tableOptions.find(x => x.collection === state.collection);
            if (tableOption)
                tableOption.value.page = 1;
        },
        SET_EXTENDED_FILTER (state, payload) {
            let item = state.extendedFilters.find(x => x.collection === state.collection);
            if (!item) {
                item = { collection: state.collection, value: payload }
                state.extendedFilters.push(item);
            }
            else 
                item.value = payload;
            const tableOption = state.tableOptions.find(x => x.collection === state.collection);
            if (tableOption)
                tableOption.value.page = 1;
        },
        SET_TABLE_OPTION (state, payload) {
            let item = state.tableOptions.find(x => x.collection === state.collection);
            if (!item) {
                item = { collection: state.collection, value: payload };
                state.tableOptions.push(item);
            }
            else 
                item.value = payload;
        },
        SET_TABLE_OPTION_PAGE (state, payload) {
            const tableOption = state.tableOptions.find(x => x.collection === state.collection);
            if (tableOption)
                tableOption.value.page = payload;
        },
        
    },
    getters: {
        getCollection: (s) => s.collection,
        getStatus: (s) => {
            const item = s.statuses.find(x => x.collection === s.collection);
            return item?.value ?? "Any";
        },
        getSearch: (s) => {
            const item = s.searches.find(x => x.collection === s.collection);
            return item?.value;
        },

        getTableOptions: (s) => {

            const item = s.tableOptions.find(x => x.collection === s.collection);

            return item?.value ??
                {
                    page: 1,
                    itemsPerPage: 10,
                    sortBy: ["regdate"],
                    sortDesc: [true],
                    groupBy: [],
                    groupDesc: [],
                    multiSort: false,
                    mustSort: false
                };
        },
        
        getExtendedFilter: (s) => {

            const item = s.extendedFilters.find(x => x.collection === s.collection);

            return item?.value ??
                {
                    EFTheme: {
                        label: "Краткое_содержание",
                        value: null
                    },
                    RegNumber: {
                        label: "Рег._номер",
                        value: null
                    },
                    RegDateFrom: {
                        label: "Дата_регистрации_c",
                        value: null
                    },
                    RegDateTo: {
                        label: "Дата_регистрации_по",
                        value: null
                    },
                    Language: {
                        label: "Язык_документа",
                        value: null
                    },
                    Executers: {
                        label: "Исполнитель",
                        value: []
                    },
                    ResolutionAuthor: {
                        label: "Автор_резолюции",
                        value: []
                    },
                    Recipients: {
                        label: "Получатель",
                        value: []
                    },
                    NomenclatureId: {
                        label: "Номенклатура",
                        value: []
                    },
                    SignerEmployeeIds: {
                        label: "Подписал",
                        value: []
                    }
                };
        },
        
    }
}